import { calculateValuePerMetrics } from "src/service/cost/data/value-per-metric";

export function CalculateCostPerValues(total: number, units: number, area: number) {
  const values = calculateValuePerMetrics(total, units, area);

  return values;
}
